import React from 'react';
import './AutomGallery.css';

function AutomGallery ({ data }) {
    window.onclick = function (event) {
        let modal = document.getElementById('myModal');
        if (event.target === modal) { modal.style.display = 'none'; }
    };
    return (
        <div data-test="bot-gallery">
            <div className="scrollmenu">
                {data?.bot_images?.map((tile) => (
                    <div key={tile.title} className="column">
                        <img className="myImg" src={tile.img} alt={tile.title} style={{ width: '100%' }}
                            onClick={function () {
                                let modal = document.getElementById('myModal');
                                let modalImg = document.getElementById('img01');
                                let captionText = document.getElementById('caption');
                                modal.style.display = 'block';
                                modalImg.src = tile.img;
                                captionText.innerHTML = tile.title;
                            }}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
}

export default AutomGallery;
